import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "./model";

const ModalForms = ({ activeModal, openModal, closeModal }) => {
  const navigate = useNavigate();

  // ✅ Dummy Employees
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    const dummyEmployees = [
      { _id: "1", user: { name: "Rahul Sharma" }, designation: "Developer" },
      { _id: "2", user: { name: "Amit Kumar" }, designation: "Designer" },
      { _id: "3", user: { name: "Sneha Gupta" }, designation: "HR" },
    ];
    setEmployees(dummyEmployees);
  }, []);

  // ---------------- Task states ----------------
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // ---------------- Expenses states ----------------
  const [expitem, setExpItem] = useState("");
  const [explocation, setExpLocation] = useState("");
  const [exppurchby, setExpPurchBy] = useState("");
  const [exppurchdate, setExpPurchDate] = useState("");
  const [expqty, setExpQty] = useState("");
  const [expamount, setExpAmount] = useState("");
  const [expstatus, setExpStatus] = useState("");

  // ---------------- Holiday states ----------------
  const [holidaytitle, setHolidayTitle] = useState("");
  const [holidaydate, setHolidayDate] = useState("");
  const [holidaydescription, setHolidayDescription] = useState("");
  const [holidaystatus, setHolidayStatus] = useState("");

  // ---------------- Salary states ----------------
  const [salaryempId, setSalaryid] = useState("");
  const [salaryempname, setSalaryname] = useState("");
  const [salaryAmount, setSalaryamount] = useState("");
  const [salarystatus, setSalarystatus] = useState("");
  const [salaryDate, setSalarydate] = useState("");

  const [loading, setLoading] = useState(false);

  // ---------------- Task Create ----------------
  const handleCreate = (e) => {
    e.preventDefault();
    if (!selectedEmployee || !title || !startDate || !endDate) return;

    const newTask = {
      id: Date.now(),
      employee: selectedEmployee,
      title,
      description,
      startDate,
      endDate,
    };

    console.log("Task Created:", newTask);

    setSelectedEmployee("");
    setTitle("");
    setDescription("");
    setStartDate("");
    setEndDate("");

    closeModal();
    navigate(`/tasks/${newTask.id}`);
  };

  // ---------------- Expenses Create ----------------
  const expensesCreate = (e) => {
    e.preventDefault();

    const newExpense = {
      id: Date.now(),
      expitem,
      explocation,
      exppurchby,
      exppurchdate,
      expqty,
      expamount,
      expstatus,
    };

    console.log("Expense Added:", newExpense);

    setExpItem("");
    setExpLocation("");
    setExpPurchBy("");
    setExpPurchDate("");
    setExpQty("");
    setExpAmount("");
    setExpStatus("");

    closeModal();
  };

  // ---------------- Holiday Create ----------------
  const holidayCreate = (e) => {
    e.preventDefault();

    const newHoliday = {
      id: Date.now(),
      holidaytitle,
      holidaydate,
      holidaydescription,
      holidaystatus,
    };

    console.log("Holiday Added:", newHoliday);

    setHolidayTitle("");
    setHolidayDate("");
    setHolidayDescription("");
    setHolidayStatus("");

    closeModal();
  };

  // ---------------- Salary Create ----------------
  const salaryCreate = (e) => {
    e.preventDefault();

    const newSalary = {
      id: Date.now(),
      salaryempId,
      salaryempname,
      salaryAmount,
      salarystatus,
      salaryDate,
    };

    console.log("Salary Added:", newSalary);

    setSalaryid("");
    setSalaryname("");
    setSalaryamount("");
    setSalarystatus("");
    setSalarydate("");

    closeModal();
  };

  return (
    <div>
      {/* Holiday */}
    <Modal
        isOpen={activeModal === "addholiday"}
        onClose={closeModal}
        title="Add Holiday"
      >
        <form onSubmit={holidayCreate}>
          <div className="formlabeldiv">
            <input
              type="text"
              value={holidaytitle}
              onChange={(e) => setHolidayTitle(e.target.value)}
            />
            <label>Title</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="date"
              value={holidaydate}
              onChange={(e) => setHolidayDate(e.target.value)}
            />
            <label>Date</label>
          </div>
          <div className="formlabeldiv">
            <select
              value={holidaystatus}
              onChange={(e) => setHolidayStatus(e.target.value)}
            >
              <option value="">Select Type</option>
              <option value="festivals">Festivals</option>
              <option value="weeklyoff">Weekly off</option>
              <option value="halfday">Half days</option>
            </select>
            <label>Event Type</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="text"
              value={holidaydescription}
              onChange={(e) => setHolidayDescription(e.target.value)}
            />
            <label>Description</label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Saving…" : "Submit"}
          </button>
        </form>
      </Modal>

      {/* Salary */}
      <Modal isOpen={activeModal === "addsalary"} onClose={closeModal} title="Add Salary">
        <form onSubmit={salaryCreate}>
          <input value={salaryempId} onChange={(e) => setSalaryid(e.target.value)} placeholder="ID" />
          <input value={salaryempname} onChange={(e) => setSalaryname(e.target.value)} placeholder="Name" />
          <input value={salaryAmount} onChange={(e) => setSalaryamount(e.target.value)} placeholder="Amount" />
          <input value={salaryDate} onChange={(e) => setSalarydate(e.target.value)} placeholder="Date" />
          <input value={salarystatus} onChange={(e) => setSalarystatus(e.target.value)} placeholder="Status" />
          <button type="submit">Submit</button>
        </form>
      </Modal>

      {/* Expenses */}
    <Modal
        isOpen={activeModal === "addexpenses"}
        onClose={closeModal}
        title="Add Expenses"
      >
        <form onSubmit={expensesCreate}>
          <div className="formlabeldiv">
            <input
              type="text"
              value={expitem}
              onChange={(e) => setExpItem(e.target.value)}
            />
            <label>Item Name</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="text"
              value={explocation}
              onChange={(e) => setExpLocation(e.target.value)}
            />
            <label>Location</label>
          </div>
          <div className="formlabeldiv">
    <select
              id="employee"
              value={exppurchby}
              onChange={(e) => setExpPurchBy(e.target.value)}
            >
              <option value="">Select an employee</option>
              {employees.map((emp) => (
                <option key={emp._id} value={emp._id}>
                  {emp.user.name}
                </option>
              ))}
            </select>

            <label>Purchase By</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="date"
              value={exppurchdate}
              onChange={(e) => setExpPurchDate(e.target.value)}
            />
            <label>Purchase Date</label>
          </div>
          <div className="formlabeldiv">
            <select
              value={expstatus}
              onChange={(e) => setExpStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="Paid">Paid</option>
              <option value="Unpaid">Unpaid</option>
            </select>
            <label>Status</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="number"
              value={expamount}
              onChange={(e) => setExpAmount(e.target.value)}
            />
            <label>Amount</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="number"
              value={expqty}
              onChange={(e) => setExpQty(e.target.value)}
            />
            <label>Qty</label>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Saving…" : "Submit"}
          </button>
        </form>
      </Modal>

      {/* Task */}
      <Modal
        isOpen={activeModal === "addtask"}
        onClose={closeModal}
        title="Add Task"
      >
        <form onSubmit={handleCreate}>
          <div className="formlabeldiv">
            <select
              id="employee"
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
            >
              <option value="">Select an employee</option>
              {employees.map((emp) => (
                <option key={emp._id} value={emp._id}>
                  {emp.user.name} ({emp.designation})
                </option>
              ))}
            </select>
            <label>Employee</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <label>Task Title</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="text"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
            <label>Task Description</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <label>Start Date</label>
          </div>
          <div className="formlabeldiv">
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <label>End Date</label>
          </div>

          <button
            type="submit"
            disabled={loading || !selectedEmployee || !title || !startDate || !endDate}
          >
            {loading ? "Assigning…" : "Create Assignment"}
          </button>
        </form>
      </Modal>
    </div>
  );
};

export default ModalForms;